// src/components/LogosFooter.jsx
import React from 'react';
import { Row, Col } from 'antd';
import logoProsperidad from '../../assets/logo_prosperidad_blanco.png';
import logo472 from '../../assets/logo_472.png';



import './LogosFooter.css'; // Archivo CSS para estilos

const LogosFooter = () => {
    return (
        <div className="logos-footer">
            <Row gutter={[32, 32]} justify="center" align="middle">
                <Col xs={12} sm={6} md={4} lg={3}>
                    <a href="https://prosperidadsocial.gov.co" target="_blank" rel="noopener noreferrer">
                        <img src={logoProsperidad} alt="ART Logo" className="logo-image" />
                    </a>
                </Col>
                <Col xs={12} sm={6} md={4} lg={3}>
                    <a href="https://www.4-72.com.co" target="_blank" rel="noopener noreferrer">
                        <img src={logo472} alt="Logo FAO" className="logo-image" />
                    </a>
                </Col>

            </Row>
        </div>
    );
};

export default LogosFooter;
